export default "__VITE_ASSET__BpC989g2__"